/* global Sys, Services, Core */
Sys.ns("Core");

Core.LoadProgressHandler = {
    constructor: function() {
        Core.LoadProgressHandler.superclass.constructor.apply(this, arguments);

        this._progress = 0;
        this._isLoadAnimationCompleted = false;
        this._isCompleted = false;

        this.setupEvents();
    },

    setupEvents: function() {
        this.observable.addListener(
            "request:loadProgressHandler.handlePluginTimeoutError",
            this.error.bind(this, Core.LoadProgressErrorTypes.PLUGIN_TIMEOUT_ERROR)
        );

        this.observable.addListener(
            "request:loadProgressHandler.showTechnicalError",
            this.error.bind(this, Core.LoadProgressErrorTypes.TECHNICAL_ERROR)
        );
    },

    /**
     * Takes progress value and notifies about loading progress.
     *
     * @param {number} value Total loading progress value.
     * @returns {void}
     */
    setProgress: function(value) {
        this._progress = value;
        this.publish(Core.LoadProgressEvents.PROGRESS, value);
    },

    /**
     * Returns current progress.
     *
     * @returns {number} Progress.
     */
    getProgress: function() {
        return this._progress;
    },

    /**
     * Notifies that load animation is completed.
     *
     * @returns {void}
     */
    loadAnimationCompleted: function() {
        this._isLoadAnimationCompleted = true;
        this.publish(Core.LoadProgressEvents.LOAD_ANIMATION_COMPLETED);
    },

    /**
     * Notifies that loading is completed.
     *
     * @returns {void}
     */
    complete: function() {
        this._isCompleted = true;
        this.publish(Core.LoadProgressEvents.COMPLETED);
    },

    /**
     * Returns whether LPH completed or not.
     *
     * @returns {boolean} Whether LPH completed or not.
     */
    isCompleted: function() {
        return this._isCompleted;
    },

    /**
     * Sends 'show' event.
     *
     * @returns {void}
     */
    show: function() {
        this.publish(Core.LoadProgressEvents.SHOW);
    },

    /**
     * Sends 'hide' event.
     *
     * @returns {void}
     */
    hide: function() {
        this.publish(Core.LoadProgressEvents.HIDE);
    },

    /**
     * Notifies about loading errors.
     *
     * @private
     * @param {Object} type Error type.
     * @param {Object} errorData Error data.
     * @returns {void}
     */
    error: function(type, errorData) {
        this.publish(Core.LoadProgressEvents.ERROR, type, errorData);
    },

    /**
     * Notifies about error dialogs.
     *
     * @private
     * @param {Object} dialogConfig Error config.
     * @returns {void}
     */
    showDialog: function(dialogConfig) {
        this.publish(Core.LoadProgressEvents.DIALOG, dialogConfig);
    }
};

Core.LoadProgressHandler = Sys.extend(Services.Base, Core.LoadProgressHandler, "Core.LoadProgressHandler");

Core.LoadProgressEvents = {
    PROGRESS: "progress",
    COMPLETED: "completed",
    LOAD_ANIMATION_COMPLETED: "loadAnimationCompleted",
    SHOW: "show",
    HIDE: "hide",
    ERROR: "error",
    DIALOG: "dialog"
};

Core.LoadProgressErrorTypes = {
    REQUEST_ERROR: "requestError",
    TECHNICAL_ERROR: "technicalError",
    PLUGIN_TIMEOUT_ERROR: "pluginTimeoutError"
};
